import { Modal, Form, Input, InputNumber, Select, Alert, message } from "antd";
import { ApiService } from "api/api.service";
import { useEffect } from "react";

const RechargeCreditsModal = ({
  open,
  onClose,
  refetch,
}: {
  open: boolean;
  onClose: () => void;
  refetch: () => void;
}) => {
  const [form] = Form.useForm();

  const { data: models, isLoading: modelsLoading } = ApiService.credit.useGetCreditModels();

  const rechargeMutation = ApiService.credit.useRechargeCredits();

  const handleSubmit = async () => {
    const values = await form.validateFields();

    rechargeMutation.mutate(
      {
        id: values.id,
        amount: values.amount,
        payment: values.payment,
        description: values.description,
        user: values.user,
        application: values.application,
      },
      {
        onSuccess: () => {
          message.success("Credits recharge logged successfully!");

          form.resetFields();
          refetch();
          onClose();
        },
      },
    );
  };

  useEffect(() => {
    if (!open) form.resetFields();
  }, [open]);

  return (
    <Modal
      title="Log Credit Recharge"
      open={open}
      onCancel={onClose}
      onOk={handleSubmit}
      confirmLoading={rechargeMutation.isPending}
      centered
    >
      <Alert
        showIcon
        className="mb-4"
        type="warning"
        message="Only users with developer access can perform this action."
      />

      <Form form={form} layout="vertical">
        <Form.Item name="id" label="Credit Model" rules={[{ required: true, message: "Select a model" }]}>
          <Select
            loading={modelsLoading}
            options={models?.result?.map((m) => ({
              label: m.title,
              value: m.value,
            }))}
          />
        </Form.Item>

        <Form.Item name="amount" label="Number of credits added" rules={[{ required: true, message: "Enter amount" }]}>
          <InputNumber style={{ width: "100%" }} min={1} />
        </Form.Item>

        <Form.Item
          name="payment"
          label="Amount paid for recharge"
          rules={[{ required: true, message: "Enter payment" }]}
        >
          <InputNumber style={{ width: "100%" }} min={1} />
        </Form.Item>

        <Form.Item name="description" label="Description">
          <Input.TextArea rows={3} />
        </Form.Item>

        <Form.Item name="application" label="Application ID">
          <Input />
        </Form.Item>

        <Form.Item name="user" label="User ID">
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RechargeCreditsModal;
